import { render } from "./RegPwd.vue?vue&type=template&id=5e6a0898"
import script from "./RegPwd.vue?vue&type=script&lang=js"
export * from "./RegPwd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__